import {Button as MuiButton, styled} from '@mui/material';


const Button = styled(MuiButton)(({theme, size, allrounded = false}) => {
  let height = 42
  let rounded = "12px";
  if (size === 'large') {
    height = 52;
    rounded = "12px";
  } else if (size === 'small') {
    height = 36;
    rounded = "12px";
  }
  if (allrounded) {
    rounded = `${height / 2}px`;
  }

  return ({
    fontWeight: 500,
    lineHeight: 1,
    height: `${height}px`,
    // color: "#D6D6DF",
    borderRadius: rounded,
    whiteSpace: "nowrap",
    color: theme === "dark" ? theme.palette.white : theme.palette.black,
    fontSize: "16px",

  })
});

const RoundButton = styled(Button)(({theme}) => {
  return {
    // borderRadius: '25%',
  }
})

export default Button
export {Button, RoundButton}
